<template>
  <div class="page">
    <header class="page-header">
      <h1>Configurações</h1>
      <p class="muted">Ações administrativas restritas ao ROOT.</p>
    </header>

    <section class="card danger-zone">
      <div class="dz-header">
        <h2>Zona de perigo</h2>
        <span class="dz-badge">irreversível</span>
      </div>
      <p class="muted">
        Resetar o encontro apaga <strong>todos os participantes</strong>, suas fotos de bagagem
        e <strong>todos os admins/voluntários</strong> (exceto você). Use ao iniciar um novo encontro.
      </p>

      <button class="btn-danger" @click="abrirModal" :disabled="loading">
        Resetar encontro
      </button>
    </section>

    <transition name="fade">
      <div v-if="modalOpen" class="modal-overlay" @click.self="fechar">
        <div class="modal-card">
          <h3>Tem certeza?</h3>
          <p>Esta ação é <strong>irreversível</strong>. Pra confirmar, digite sua senha.</p>

          <form @submit.prevent="confirmar">
            <input
              v-model="password"
              type="password"
              placeholder="Sua senha"
              class="input"
              autocomplete="current-password"
              :disabled="loading"
            />

            <div v-if="erro" class="erro">{{ erro }}</div>

            <div class="modal-actions">
              <button type="button" class="btn-secondary" @click="fechar" :disabled="loading">
                Cancelar
              </button>
              <button type="submit" class="btn-danger" :disabled="loading || !password">
                {{ loading ? 'Resetando…' : 'Confirmar reset' }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import api from '../lib/api'

export default {
  name: 'ConfiguracoesPage',
  data() {
    return {
      modalOpen: false,
      password: '',
      loading: false,
      erro: ''
    }
  },
  methods: {
    abrirModal() {
      this.password = ''
      this.erro = ''
      this.modalOpen = true
    },
    fechar() {
      if (this.loading) return
      this.modalOpen = false
    },
    async confirmar() {
      this.erro = ''
      this.loading = true
      try {
        const { data } = await api.post('/encontro/reset', { password: this.password })
        const partes = [
          `${data.participantsDeleted} participantes`,
          `${data.adminsDeleted} admins/voluntários`,
          `${data.photosDeleted}/${data.photosTotal} fotos`
        ]
        this.$toast.open({
          message: `Encontro resetado: ${partes.join(' · ')}`,
          type: 'success',
          position: 'top-right',
          duration: 6000
        })
        this.modalOpen = false
        this.password = ''
      } catch (err) {
        this.erro = err.response?.data?.message || 'Falha ao resetar. Tente novamente.'
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.page {
  max-width: 720px;
  margin: 0 auto;
  padding: var(--spacing-base);
  display: flex;
  flex-direction: column;
  gap: var(--spacing-base);
}
.page-header h1 { margin: 0 0 4px; }
.muted { color: var(--color-text-muted); margin: 0; font-size: var(--text-sm); }

.danger-zone {
  border: 1px solid #fecaca;
  background: #fef2f2;
  padding: var(--spacing-base);
  border-radius: var(--radius-md);
  display: flex;
  flex-direction: column;
  gap: var(--spacing-sm);
}
.dz-header {
  display: flex; align-items: center; gap: var(--spacing-sm);
}
.dz-header h2 { margin: 0; color: #991b1b; font-size: var(--text-md); }
.dz-badge {
  background: #dc2626; color: white;
  padding: 2px 8px; border-radius: 99px; font-size: 10px;
  text-transform: uppercase; font-weight: 600;
}

.btn-danger {
  background: #dc2626; color: white; border: 0;
  padding: 10px 16px; border-radius: var(--radius-md);
  font-weight: 600; cursor: pointer;
  align-self: flex-start;
}
.btn-danger:hover:not(:disabled) { background: #b91c1c; }
.btn-danger:disabled { opacity: 0.5; cursor: not-allowed; }

.btn-secondary {
  background: var(--color-bg-hover); color: var(--color-text);
  border: 0; padding: 10px 16px; border-radius: var(--radius-md);
  font-weight: 500; cursor: pointer;
}

.modal-overlay {
  position: fixed; inset: 0;
  background: rgba(0,0,0,0.5);
  display: flex; align-items: center; justify-content: center;
  z-index: 100; padding: var(--spacing-base);
}
.modal-card {
  background: white; border-radius: var(--radius-md);
  padding: var(--spacing-lg); max-width: 460px; width: 100%;
  box-shadow: 0 10px 40px rgba(0,0,0,0.2);
}
.modal-card h3 { margin: 0 0 8px; color: #991b1b; }
.modal-card p { color: var(--color-text-muted); margin: 0 0 var(--spacing-base); font-size: var(--text-sm); }
.input {
  width: 100%; padding: 10px 12px;
  border: 1px solid var(--color-border);
  border-radius: var(--radius-md); font-size: var(--text-base);
  margin-bottom: var(--spacing-sm);
}
.erro {
  background: #fee2e2; color: #b91c1c;
  padding: 8px 12px; border-radius: var(--radius-md);
  font-size: var(--text-sm); margin-bottom: var(--spacing-sm);
}
.modal-actions {
  display: flex; gap: var(--spacing-sm); justify-content: flex-end;
}

.fade-enter-active, .fade-leave-active { transition: opacity 0.15s; }
.fade-enter-from, .fade-leave-to { opacity: 0; }
</style>
